
// import React from 'react'
import "../Delete/DeleteGroup.css";
import "../SucessGroup/DeleteGroupSucesFully.css";

import { useState } from "react";
import CreateMoreGroups from "../CreteMoreGroup/CreateMoreGroups";

export default function SuccessMemberAdded({ setMessage }) {
  const { click } = useState(false);

  return (
    <div>
      {!click && (
        <div className="deleteGroupAll_sucessFUlly ">
          <div className="delete_success_container col-md-5 col-10 ">
            <div className="d-flex">
              <img
                className="group_profile_img "
                src="/group-img/GroupSuccess.svg"
                alt=""
              ></img>
            </div>
            <div className="group_delete_sucessFullyMsg ">
              Member's Added successfully!
            </div>
            <button
              onClick={() => {
                setMessage(false);
              }}
              className="okay_btn_group"
            >
              Okay
            </button>
          </div>
         
        </div>
      )}
      {click && <CreateMoreGroups />}
    </div>
  );
}
